<template>
  <section class="pes" aria-labelledby="providers-empty-h">
    <div class="pes-icon" aria-hidden="true">
      <v-icon size="34">mdi-account-plus-outline</v-icon>
    </div>
    <h2 id="providers-empty-h" class="pes-title">No providers yet</h2>
    <p class="pes-desc">
      Add a provider to see how often AI recommends them when patients ask for care, and who AI lists instead.
    </p>
    <button type="button" class="pes-cta" @click="$emit('add')">+ Add provider</button>
    <span class="pes-hint">You'll need the provider's name or NPI number.</span>
    <div class="pes-cards">
      <div v-for="c in cards" :key="c.title" class="pes-card">
        <v-icon size="22" color="primary">{{ c.icon }}</v-icon>
        <strong>{{ c.title }}</strong>
        <span>{{ c.text }}</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProviderEmptyState',
  emits: ['add'],
  data() {
    return {
      cards: [
        {
          icon: 'mdi-chart-line',
          title: 'Provider Visibility Score',
          text: 'How often, and how high, AI recommends the provider over time.'
        },
        {
          icon: 'mdi-format-list-numbered',
          title: 'Where AI ranks them',
          text: "AI's top 5 providers for each patient question, and the sources it used."
        },
        {
          icon: 'mdi-compare-horizontal',
          title: 'How they compare',
          text: 'The providers AI lists next to them, side by side on what AI looks for.'
        }
      ]
    }
  }
}
</script>

<style scoped>
.pes {
  background: #fff;
  border: 1px solid #e6e1d4;
  border-radius: 12px;
  padding: 56px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
  color: var(--brand-ink-950);
}
.pes-icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: var(--brand-ocean-100);
  color: var(--brand-ocean-600);
  display: flex;
  align-items: center;
  justify-content: center;
}
.pes-title { margin: 0; font-family: inherit; font-size: 24px; font-weight: 700; }
.pes-desc { margin: 0; color: #4a5568; max-width: 520px; }
.pes-cta {
  height: 48px;
  padding: 0 22px;
  border: none;
  border-radius: 10px;
  background: var(--brand-ocean-600);
  color: #fff;
  font: inherit;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
}
.pes-cta:hover { background: #174d7c; }
.pes-hint { font-size: 13px; color: #4a5568; }
.pes-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  width: 100%;
  max-width: 960px;
  margin-top: 24px;
  text-align: left;
}
.pes-card {
  border: 1px solid #e6e1d4;
  border-radius: 10px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  background: var(--brand-sand-50);
}
.pes-card span { font-size: 14px; color: #4a5568; }
</style>
